export const arrayToArrayObject = ({
  key,
  subKey,
  erase = [],
  data,
}: {
  key: string;
  subKey?: string;
  erase?: Array<string>;
  data: Array<object>;
}) => {
  let tempValues: any = {};
  data.forEach((c: any) => {
    let tempObj = { ...c };
    if (!c[key]) return;
    if (!tempValues[c[key]]) {
      tempValues[c[key]] = subKey ? {} : [];
    }
    erase.forEach((e) => delete tempObj[e]);
    if (subKey) {
      tempValues[c[key]][c[subKey]] = tempObj;
    } else {
      tempValues[c[key]].push(tempObj);
    }
  });
  return tempValues;
};
